import { render, staticRenderFns } from "./PersonalInfoForm.vue?vue&type=template&id=5a69baa4&scoped=true&"
import script from "./PersonalInfoForm.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoForm.vue?vue&type=style&index=0&id=5a69baa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a69baa4",
  null
  
)

export default component.exports